import { render, staticRenderFns } from "./delete-category-modal.vue?vue&type=template&id=3251a8d2&scoped=true&"
import script from "./delete-category-modal.vue?vue&type=script&lang=js&"
export * from "./delete-category-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3251a8d2",
  null
  
)

export default component.exports